import { sortBy } from 'lodash'

export const sortSpans = (spans) => sortBy(spans, ['timestamp'], ['asc', 'asc'])
